<template>
  <div class="scan">
    <!--   谈宝头部-->
    <!-- <div class="scan-header">
      <i></i>
      <span class="scan-title">谈宝</span>

      <div class="tabbar">
        <Tab :navbarList="navbarList" showNab="1"></Tab>
      </div>
    </div> -->
    <!-- 轮播图 -->
    <div class="background">
      <!--div-- id="app">
        <CarouselComponent
          :visibleItems="numberOfVisibleItems"
          :productList="productAdvertApplyList"
          :storeId="storeId"
          :userId="userId"
        />
      </div-->

      <!--    谈宝主体-->
      <div class="container">
        <router-view></router-view>
      </div>
    </div>
    <!--    发布谈宝内容-->
    <van-popup v-model="showPublish" round position="bottom" :style="{ height: '40%' }">
      <ul class="publish-content">
        <li @click="handleMyPublishedClick">我发布的</li>
        <li @click="cancelPublish('发布图片')">发布图片</li>
        <li @click="cancelPublish('发布视频')">发布视频</li>
        <li @click="cancelPublish">取消</li>
      </ul>
    </van-popup>
    <!--    视频播放-->
    <van-overlay :show="showVideo">
      <div class="wrapper">
        <div class="block">
          <div class="back-icon">
            <van-icon name="arrow-left" color="#ffffff" size="0.4rem" @click="closeVideo"/>
          </div>
          <video class="videoStyle" ref="pauseVideo" controls :src="filterImg" autoplay="autoplay"></video>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import api from '../../utils/api'
import {aGet, aPost} from '../../utils/request'
import $ from 'jquery'
import Tab from '../../components/Tab/Tab'
import {mapGetters, mapActions} from 'vuex'
import CarouselComponent from './components/CarouselComponent.vue'

export default {
  components: {
    Tab: Tab,
    CarouselComponent: CarouselComponent
  },
  data() {
    return {
      vueAppTypeName: process.env.VUE_APP_TYPE_NAME || '',
      navbarList: [
        {typeName: '谈宝', path: '/scan'},
        {typeName: '游戏', path: '/Game'},
        {typeName: '直播', path: 'Live'}
      ],
      showPublish: false,
      showVideo: false,
      filterImg: '',
      numberOfVisibleItems: 3,
      productAdvertApplyList: [], // 初始化数据
      storeId: null,
      userId: null
    }
  },
  methods: {
    // 我发布的
    handleMyPublishedClick() {
      this.$router.push({ path: '/MyDynamics' })
      this.setShowPublish(false)
    },
    // 谈宝广场列表
    async getBalkBabyList() {
      //获取经纬度
      let location = JSON.parse(sessionStorage.getItem('location')) || ''
      if (location) {
        this.paramObj['dynamicLatitude'] = location.latitude
        this.paramObj['dynamicLongitude'] = location.longitude
      } else {
        this.paramObj['dynamicLatitude'] = '23.079777'
        this.paramObj['dynamicLongitude'] = '113.296359'
      }
      console.log('谈宝广场请求参数：', this.paramObj);

      let res = await this.$http.aPost(this.$api.getDynamicyList, this.paramObj)
      console.log('谈宝广场列表:', JSON.stringify(res));
      if (res.status === 200) {
        if (this.talkBabyList.length === 0) {
          this.talkBabyList = res.data.dynamics
        } else {
          this.talkBabyList = this.talkBabyList.concat(res.data.dynamics)
        }
        this.isLoad = res.data.dynamics.length >= 10
        this.bottomNavbarList = [{id: 0, typeName: "全部"}, ...res.data.types]
      }
    },
    //轮播图数据
    fetchCarouselList() {
      const parma = {
        pageNum: 1,
        pageSize: 100,
      }; // 设置 storeId=0
      aPost(api.getCarouselList, parma).then(res => {
        console.log('轮播图:', res);
        // 过滤掉 productInfo 为 null 的项
        this.productAdvertApplyList = res.data.carouselList.filter(item => item.productInfo !== null);
        // console.log("过滤后的轮播图："+res.data.carouselList.filter(item => item.productInfo !== null));
      }).catch(error => {
        console.error('获取数据失败', error);
      });
    },

    ...mapActions(['setShowPublish', 'setVideoSrc', 'setVideoShow']),
    //是否发布谈宝内容
    cancelPublish(value) {
      if (value === '发布视频') {
        this.$router.push({name: 'publish', params: {name: value}})
      } else if (value === '发布图片') {
        this.$router.push({name: 'publishimg', params: {name: value}})
      }
      this.setShowPublish(false)
    },
    //关闭视频
    closeVideo() {
      // console.log(this.$refs.pauseVideo);
      this.$refs.pauseVideo.pause()
      this.showVideo = false
    }
  },
  computed: {
    ...mapGetters(['getShowPublish', 'getVideoSrc', 'getVideoShow']),
    bmTab() {
      return this.$store.state.bmTab
    }
  },
  watch: {
    //关闭发布
    showPublish(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setShowPublish(newValue)
      }
    },
    //打开发布
    getShowPublish(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.showPublish = newValue
      }
    },
    //打開视频
    getVideoShow(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.showVideo = newValue
        this.filterImg = this.getVideoSrc
      }
    },
    //关闭视频
    showVideo(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setVideoShow(newValue)
      }
    }
  },
  created() {
    this.$store.state.bmTab = 3;
    this.storeId = localStorage.getItem('storeId');
    this.userId = localStorage.getItem('id');
  },

  mounted() {
    // this.aboutValuda();
    //this.fetchCarouselList();
  },
  updated() {
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/mixin';

.background {
  position: relative; /* 让伪元素相对于这个元素定位 */
  background: linear-gradient(to bottom left, #8bc2d2, #00008b);
  width: 100%;
}

.background::before {
  content: '';
  position: absolute;
  top: -86px; /* 调整亮斑的位置 */
  left: -50px; /* 调整亮斑的位置 */
  width: 180px; /* 调整亮斑的宽度 */
  height: 180px; /* 调整亮斑的高度 */
  background: radial-gradient(circle, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0) 100%); /* 调整透明度，改善边缘过渡 */
  border-radius: 50%; /* 使亮斑为圆形 */
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3); /* 添加更柔和的阴影效果 */
}


.scan {
  background: linear-gradient(to bottom left, #8bc2d2, #00008b);
  width: 100%;
  height: 100%;
  //头部
  .scan-header {
    width: 100%;
    height: 86px;
    padding: 30px 0 16px 32px;
    background-color: #ffffff;
    position: fixed;
    top: 54px;
    left: 0;

    i {
      display: inline-block;
      width: 40px;
      height: 40px;
      background: url('../../assets/img/baby/talk-baby.png') center center no-repeat;
      background-size: contain;
      vertical-align: -6px;
      margin-right: 16px;
    }

    span {
      display: inline-block;
      font-size: 34px;
      color: #dc6a2b;
      line-height: 34px;
      font-weight: bold;
    }

    //顶部Tab
    .tabbar {
      width: 100%;
      margin-top: 18px;
      background-color: #ffffff;
      //padding: 0 32px;
    }
  }

  //内容区域
  .container {
    min-height: 20rem;
    width: 100%;
    padding: 0 32px;
    border-radius: 30px;
    background-color: #ffffff;
    padding-top: 28px;
    padding-bottom: 180px;
    position: relative; // 改为 relative
    overflow-y: auto; // 允许内容滚动
  }

  //发布内容
  .publish-content {
    width: 100%;
    padding: 0 24px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    li {
      width: 100%;
      height: 104px;
      border-bottom: 1px solid #f2f2f2;
      line-height: 104px;
      text-align: center;
      font-size: 32px;
      color: #222222;

      &:last-child {
        border: none;
      }
    }
  }

  /deep/ .van-overlay {
    z-index: 12;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .block {
      width: 100%;
      height: 100%;

      .back-icon {
        width: 100%;
        height: 96px;
        padding: 0 20px;
        background-color: #000;
        position: relative;

        /deep/ .van-icon {
          position: absolute !important;
          top: 80px;
          transform: translateY(-50%);
        }
      }

      .videoStyle {
        width: 100%;
        height: calc(100% - 96px);
        background-color: #000000;
      }
    }
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/scan/scan.vue